export default "__VITE_ASSET__8X8KDVxw__"